module.exports = __webpack_public_path__ + "media/images/shared/logotypes/logo_boras-5bfd4e45c696a9824bba31bf940c3ad8.png";